/** * @author Akhila Sattarapu * @email 83606@global.ul.com * @create date
2019-12-26 15:17:50 * @modify date 2019-12-26 15:17:50 * @desc Confirmation
modal */
<template>
  <div>
    <div id="feedbackPopup" class="modal custom" role="dialog">
      <div class="modal-dialog request-modal">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="p-confirm">
              <div>
                <div class="check_feedback">
                  <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                </div>
                <h3 class="confirm_title">We would love to hear from you</h3>
              </div>
              <div>RAMS is strongly committed to providing you with the finest customer experience possible. We would appreciate your feedback about our services. If you would be willing to spend a couple of minutes to share your insight on our performance,</div>
              <div>
                please click
                <a
                  id="feedback_link"
                  class="feedback-link"
                  :href="feedbackurl"
                  target="_blank"
                  @click="closePopup"
                >here.</a>
              </div>
              <div
                class="footer-message"
              >(Page would automatically redirect within {{timer}} seconds)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  data() {
    return {
      timer: 10,
      interval: null,
      feedbackurl: '',
    };
  },
  methods: {
    updateTimer() {
      this.timer -= 1;
      if (this.timer === 0) {
        $('#feedback_link')[0].click();
        this.closePopup();
      }
    },
    closePopup() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Feedback link',
      });
      $('#feedbackPopup').modal('hide');
    },
  },
  mounted() {
    if (process.env.VUE_APP_MODE === 'production') {
      this.feedbackurl = 'https://survey.us.confirmit.com/wix/p3090969334.aspx';
    } else {
      this.feedbackurl = '/layout/dashboard';
    }
    $('#feedbackPopup').on('show.bs.modal', () => {
      this.interval = setInterval(this.updateTimer, 1000);
    });
    $('#feedbackPopup').on('hidden.bs.modal', () => {
      clearInterval(this.interval);
      this.timer = 10;
    });
  },
};
</script>

<style scoped>
.p-confirm {
  padding: 20px 30px;
}
.request-modal {
  width: 30%;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}
.check_feedback {
  width: 65px;
  background: #00518a;
  padding: 10px;
  border-radius: 50px;
  height: 65px;
  color: #fff;
  margin: auto;
}
.check_feedback i {
  font-size: 40px;
}
.confirm_title {
  color: #0c3859;
  margin: 15px 0px 15px 0px;
}
.feedback-link {
  color: #00518a;
  font-weight: bold;
  text-decoration: underline !important;
}
.footer-message {
  margin-top: 30px;
  font-size: 14px;
}
.custom .close {
  font-size: 25px !important;
  color: #808080d9 !important;
  background-color: #fff !important;
  top: 0 !important;
  right: 0 !important;
}
.modal-body {
  padding-bottom: 0px;
}
@media only screen and (max-width: 767px) {
  .request-modal {
    width: auto;
  }
  .p-confirm {
    padding: 20px 20px;
  }
}
@media (min-width: 768px) and (max-width: 1200px) {
  .request-modal {
    width: 60%;
  }
}
@media only screen and (max-width: 320px){
  .request-modal{
    width: 82%;
    font-size: 12px;
  }
}
</style>
